import { CloseCircleFilled, CloseCircleOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { Col, Form, Input, Row, Spin, message } from "antd";
import { DotLoading } from "antd-mobile";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import md5 from "md5";
import qs from "qs";
import IconArrowUp from "../assets/arrow-up-sm.svg"
import {
  addToCard,
  create,
  getCusID,
  getReward,
  verify,
} from "../../controller/api_home_care";
import ModalVAT from "../modalnotification/mdVat";
import LoadingModal from "../modalnotification/modalLoading";
import SuccessModal from "../modalnotification/modalSuccess";
import { _formatDayNoHour, _formatMoney, getParamUrlByKey } from "../utils";
import { AuthContext } from "./../index";
import BackButton from "./backButton";

import Iadd from "../assets/iadd.svg";
import Idelete from "../assets/idelete.svg";
import Iedit from "../assets/iedit.svg";
import Imo from "../assets/imo.svg";
import Iticket from "../assets/ticket.png";

const CreateOrder = () => {
  const {
    goStep,
    dataIsu,
    ArrPackage,
    bonus,
    getBonus,
    subsidyAmount,
    dataCondition,
    dataCheckReDeem,
    setDataCheckReDeem,
    loadingBonus,
  } = useContext(AuthContext);

  const [vat, setVAT] = useState(null);
  const [formData, setFormData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [openDone, setOpenDone] = useState(false);
  const [clickButton, setclickButton] = useState(false);
  const [dataOrder, setDataOrder] = useState({});
  const [openDetailPac, setOpenDetailPac] = useState(false);
  const [openDetailBuyer, setOpenDetailBuyer] = useState(false);
  const [openDetailCollaborator, setOpenDetailCollaborator] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reward, setReward] = useState(0);
  const [redeemFee, setRedeemFee] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [errRedeem, setErrRedeem] = useState("");
  const [loadRedeem, setLoadRedeem] = useState(false);
  const [subsidy, setSubsidy] = useState(0);
  const [subsidyInput, setSubsidyInput] = useState("");

  const [form] = Form.useForm();
  const showReward = getParamUrlByKey("reward") === "true";
  const isApp = getParamUrlByKey("platform") === "app";

  const [collaboratorInfo, setCollaboratorInfo] = useState(null);

  const extractToken = () => {
    let t = getParamUrlByKey('token');
    if (!t && window.location.pathname) {
      const parts = window.location.pathname.split('/').filter(Boolean);
      const lastPart = parts[parts.length - 1];
      if (lastPart) {
        if (lastPart.includes('.')) {
          t = lastPart.split('.').pop();
        } else {
          t = lastPart;
        }
      }
    }
    return t;
  };

  const token = extractToken();

  useEffect(() => {
    const fetchCollaborator = async () => {
      try {
        const t = extractToken();
        if (!t) return;
        
        const SERVER_OPEN = process.env.REACT_APP_SERVER_OPEN_API || 'https://open-api-dev.globalcare.vn';
        const stimeRes = await axios.get(`${SERVER_OPEN}/v1/products/stime`, {
          headers: { Authorization: `bearer ${t}` }
        });
        if (!stimeRes?.data?.success) return;

        const stime = stimeRes.data.data.stime;
        const env = process.env.REACT_APP_NODE_ENV || "";

        const sortObjectByKey = (obj) => {
          const sortedKeys = Object.keys(obj).sort();
          const sortedObject = {};
          sortedKeys.forEach((key) => {
            sortedObject[key] = obj[key];
          });
          return sortedObject;
        };

        const data_ = qs.stringify(sortObjectByKey({}));
        const uuid = uuidv4();
        const client = md5(env + '-' + data_ + stime + uuid);
        const headers = {
          Authorization: `bearer ${t}`,
          'x-api-stime': stime,
          'x-api-nonce': uuid,
          'x-api-client': client,
        };

        const response = await axios.get(`${SERVER_OPEN}/v1/products/collaborator-detail`, { headers });
        if (response?.data?.success) {
          setCollaboratorInfo(response.data.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchCollaborator();
  }, []);

  useEffect(() => {
    async function getBalance() {
      setLoading(true);
      const res = await getReward();
      if (res?.statusCode === 200) {
        const balance = res?.result?.wallet?.balance || 0;
        const totalFee = ArrPackage[dataIsu?.package - 1]?.fees;
        const newBalance = totalFee > balance ? balance : totalFee;
        setReward(newBalance);
        //reset redeem
        form.setFieldsValue({ redeem: "" });
        setDataCheckReDeem(null);
      } else {
        message.error(res?.message || "Lỗi lấy tiền thưởng", 2);
      }
      setLoading(false);
    }

    if (showReward) {
      getBalance();
    }
  }, []);

  useEffect(() => {
    if (dataCheckReDeem?.amount > 0 || dataCheckReDeem?.redeemFull > 0) {
      setLoading(true);
      const totalFee = ArrPackage[dataIsu?.package - 1]?.fees;
      const deduct = totalFee - dataCheckReDeem?.amount;
      const newReward = deduct > reward ? reward : deduct;
      setReward(newReward);
      setRedeemFee(totalFee * (+dataCheckReDeem?.redeemFull / 100));
      setLoading(false);
    }
  }, [dataCheckReDeem?.amount]);

  useEffect(() => {
    let disCount = getParamUrlByKey("discount_code");
    window.scrollTo(0, 0);
    let dataVAT = JSON.parse(localStorage.getItem("vatTomato"));
    if (dataVAT) {
      setVAT(dataVAT);
    }
    if (isApp || getParamUrlByKey("platform") === "zalo_mini") {
      getBonus();
    }
    if (disCount && dataCondition?.display === 1) {
      form.setFieldsValue({ redeem: disCount });
      setFormData({ redeem: disCount });
      setTimeout(() => {
        checkReem();
      }, 200);
    }
    if (dataCheckReDeem?.code) {
      form.setFieldsValue({ redeem: dataCheckReDeem?.code });
    }
  }, []);

  const clearVAT = () => {
    setVAT(null);
    localStorage.removeItem("vatTomato");
  };

  const handleCancel = () => {
    let dataVAT = JSON.parse(localStorage.getItem("vatTomato"));
    setIsModalVisible(false);
    if (dataVAT) {
      setVAT(dataVAT);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        getCustomerID();
      })
      .catch((err) => {
        // console.error('err:', err);
      });
  };

  const getCustomerID = async () => {
    setShowLoading(true);
    setclickButton(true);
    let data = {
      buyerName: dataIsu?.insuredName,
      buyerDob: dataIsu?.insuredDob,
      // buyerPhone: dataIsu?.buyerPhone,
      buyerPrivateId: dataIsu?.insuredPrivateId,
      amountSaving: ArrPackage[dataIsu?.package - 1]?.fees,
    };

    const res = await getCusID(data);
    if (res?.statusCode === 200) {
      setclickButton(false);
      await createOrder(res?.result?.customerId);
      setShowLoading(false);
    } else {
      message.error(res?.message || "Có lỗi xảy ra!", 2);
      setShowLoading(false);
    }
  };

  const createOrder = async (customerId) => {
    setclickButton(true);
    let reDeem = dataCheckReDeem?.code;
    let staff_id = getParamUrlByKey("staff_id");
    let optional_partner = getParamUrlByKey("optional_partner");
    let datavat = JSON.parse(localStorage.getItem("vatTomato"));
    let dataIsu = JSON.parse(localStorage.getItem("dataIsuTomato"));
    let partnerStaffId;
    let optionalPartner;
    let redeemCode;
    let vatInfo;
    if (reDeem) {
      redeemCode = reDeem;
    }
    if (staff_id) {
      partnerStaffId = staff_id;
    }
    if (optional_partner) {
      optionalPartner = optional_partner;
    }
    if (datavat) {
      vatInfo = datavat;
    }
    let data = {
      productCode: "tomato",
      providerId: 7,
      productId: 28,
      redeemCode,
      appliedCommissionAmount: subsidy || 0,
      reward: showReward ? 1 : undefined,
      insuredInfo: {
        buyerName: dataIsu?.insuredName,
        buyerPrivateId: dataIsu?.insuredPrivateId,
        buyerDob: dataIsu?.insuredDob,
        buyerPhone: dataIsu?.buyerPhone,
        buyerEmail: dataIsu?.buyerEmail,
        buyerAddress: dataIsu?.buyerAddress,
        customerId: customerId,
        amountSaving: ArrPackage[dataIsu?.package - 1]?.fees,
        yearsOfInsurance: 1,
        packageId: dataIsu?.package,
        packageName: ArrPackage[dataIsu?.package - 1]?.title,
        partnerStaffId,
        optionalPartner,
        vatInfo,
        affArticleUid: getParamUrlByKey("aff_article_uid") || undefined
      },
      insuredPeople: {
        insuredName: dataIsu?.insuredName,
        insuredPrivateId: dataIsu?.insuredPrivateId,
        insuredDob: dataIsu?.insuredDob,
        insuredPhone: dataIsu?.buyerPhone,
        insuredEmail: dataIsu?.buyerEmail,
        insuredAddress: dataIsu?.buyerAddress,
      },
    };

    const res = isApp ? await addToCard(data) : await create(data);

    if (res?.statusCode === 200) {
      OpenDone();
      setclickButton(false);
      setDataOrder(res.result);
      // FIXME
      localStorage.removeItem("dataIsuTomato");
      localStorage.removeItem("vatTomato");
    } else {
      message.error("Tạo đơn hàng không thành công: " + res?.message, 5);
      setclickButton(false);
    }
  };

  const checkReem = async () => {
    setLoadRedeem(true);
    let data = {
      productId: 28,
      amount: ArrPackage[dataIsu?.package - 1]?.fees,
      packageCode: "P" + ArrPackage[dataIsu?.package - 1]?.id,
      yearsOfInsurance: 1,
    };

    const res = await verify(form.getFieldValue("redeem"), data);
    if (res?.statusCode === 200) {
      setDataCheckReDeem(res.result);
      setErrRedeem(res.message);
    } else {
      setErrRedeem(res?.message);
      // form.setFieldsValue({ redeem: "" });
      setDataCheckReDeem({});
    }
    setLoadRedeem(false);
  };

  const OpenDone = () => {
    setOpenDone(!openDone);
  };

  const openDetail = (index) => {
    switch (index) {
      case 1:
        setOpenDetailPac(!openDetailPac);
        break;
      case 2:
        setOpenDetailBuyer(!openDetailBuyer);
        break;
      default:
        break;
    }
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const clearRedeem = () => {
    setRedeemFee(0);
    form.setFieldsValue({ redeem: "" });
    setDataCheckReDeem({});
    setErrRedeem("");
  };

  return (
    <div style={{ fontSize: 14 }}>
      <Form form={form} onFinish={onFinish} name="stepDone">
        <Row>
          <Col
            style={{
              borderBottom: "1px solid #009B4B",
              background: "#ffffff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            xs={24}
          >
            <div
              onClick={() => openDetail(1)}
              style={{
                fontWeight: 600,
                padding: "2% 3%",
                fontSize: 15,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div>Thông tin gói bảo hiểm</div>
              <div>
                <img style={{ width: 12 }} src={Imo} alt="edit icon" />
              </div>
            </div>
          </Col>
          <Row style={{ display: openDetailPac ? "" : "none" }}>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "1px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "100px" }}>
                Gói bảo hiểm
              </div>
              <div style={{ fontWeight: 500 }}>
                {ArrPackage[dataIsu?.package - 1]?.title}
              </div>
            </Col>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "10px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "150px" }}>
                Thời hạn bảo hiểm
              </div>
              <div style={{ fontWeight: 500, textAlign: "right" }}>
                <span>1 năm</span>
                <br />
                <span style={{ fontWeight: 400, fontSize: 12 }}>
                  {/* {dataIsu?.beginDate + ' - ' + dataIsu?.endDate} */}
                  {_formatDayNoHour(moment().toDate()) +
                    " - " +
                    _formatDayNoHour(moment().add(1, "y").toDate())}
                </span>
              </div>
            </Col>
          </Row>
          <Col
            style={{ borderBottom: "1px solid #009B4B", background: "#ffffff" }}
            xs={24}
          >
            <div
              onClick={() => openDetail(2)}
              style={{
                fontWeight: 600,
                padding: "2% 3%",
                fontSize: 15,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div>Thông tin người mua bảo hiểm</div>
              <div>
                <img style={{ width: 12 }} src={Imo} alt="edit icon" />
              </div>
            </div>
          </Col>
          <Row style={{ display: openDetailBuyer ? "" : "none" }}>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "1px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "150px" }}>
                Họ và tên
              </div>
              <div style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {dataIsu?.insuredName}
              </div>
            </Col>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "1px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "150px" }}>
                Ngày sinh
              </div>
              <div style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {dataIsu?.insuredDob}
              </div>
            </Col>
            <Col
              style={{
                borderBottom: "10px solid #EDEFFA",
                padding: "2% 3%",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "150px" }}>
                Số điện thoại
              </div>
              <div style={{ fontWeight: 500, textTransform: "capitalize" }}>
                {dataIsu?.buyerPhone}
              </div>
            </Col>
          </Row>

          {token && collaboratorInfo && (
            <>
              <Col
                style={{
                  borderBottom: "1px solid #009B4B",
                  background: "#ffffff",
                  cursor: "pointer",
                }}
                xs={24}
                onClick={() => setOpenDetailCollaborator(!openDetailCollaborator)}
              >
                <div
                  style={{
                    fontWeight: 600,
                    padding: "2% 3%",
                    fontSize: 15,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div>Thông tin cộng tác viên</div>
                  <div>
                    <img style={{ width: 12, transform: openDetailCollaborator ? "rotate(180deg)" : "none", transition: "transform 0.2s" }} src={Imo} alt="dropdown icon" />
                  </div>
                </div>
              </Col>
              <Row style={{ display: openDetailCollaborator ? "" : "none", width: "100%" }}>
                <Col
                  style={{
                    padding: "2% 3%",
                    borderBottom: "1px solid #EDEFFA",
                    background: "#ffffff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  xs={24}
                >
                  <div style={{ fontSize: 12, color: "#9A9A9A", width: "150px" }}>
                    Họ và tên
                  </div>
                  <div style={{ fontWeight: 500 }}>
                    {collaboratorInfo.fullname || '---'}
                  </div>
                </Col>
                <Col
                  style={{
                    padding: "2% 3%",
                    borderBottom: "10px solid #EDEFFA",
                    background: "#ffffff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                  xs={24}
                >
                  <div style={{ fontSize: 12, color: "#9A9A9A", width: "150px" }}>
                    Mã số thuế
                  </div>
                  <div style={{ fontWeight: 500 }}>
                    {collaboratorInfo.taxCode || '---'}
                  </div>
                </Col>
              </Row>
            </>
          )}

          <Col
            style={{
              borderBottom: "1px solid #009B4B",
              background: "#ffffff",
              display: vat ? "none" : "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            xs={24}
          >
            <div style={{ padding: "2% 3%" }}>
              <span style={{ fontWeight: 600 }}>
                Xuất hóa đơn VAT (không bắt buộc)
              </span>
            </div>
            <img
              onClick={showModal}
              style={{ width: 18, marginRight: "3%" }}
              src={Iadd}
              alt="edit icon"
            />
          </Col>
          <Row style={{ display: vat ? "" : "none" }}>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "5px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              xs={24}
            >
              <div>
                <span style={{ fontWeight: 600 }}>Thông tin xuất hóa đơn</span>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  onClick={showModal}
                  style={{ width: 18, marginRight: 15 }}
                  src={Iedit}
                  alt="edit icon"
                />
                <img
                  onClick={clearVAT}
                  style={{ width: 18 }}
                  src={Idelete}
                  alt="delete icon"
                />
              </div>
            </Col>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "1px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "180px" }}>
                Tên công ty/ tên cá nhân
              </div>
              <div
                style={{
                  fontWeight: 500,
                  textAlign: "right",
                  textTransform: "capitalize",
                }}
              >
                {vat?.name}
              </div>
            </Col>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "1px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "100px" }}>
                Mã số thuế
              </div>
              <div style={{ fontWeight: 500 }}>{vat?.taxCode}</div>
            </Col>
            <Col
              style={{
                padding: "2% 3%",
                borderBottom: "10px solid #EDEFFA",
                background: "#ffffff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
              xs={24}
            >
              <div style={{ fontsize: 12, color: "#9A9A9A", width: "100px" }}>
                Địa chỉ
              </div>
              <div style={{ fontWeight: 500, textAlign: "right" }}>
                {vat?.address}
              </div>
            </Col>
          </Row>
          <Col style={{ background: "#F6F6F6" }} xs={24}>
            <div style={{ padding: "5% 3% 2% 3%" }}>
              <div style={{ fontWeight: 600, fontSize: 16 }}>
                Tổng phí bảo hiểm sau thuế
              </div>
            </div>
            <div
              style={{
                padding: "0px 3% 0px 3%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontsize: 12, color: "#646D69", width: "150px" }}>
                {ArrPackage[dataIsu?.package - 1]?.title}
              </div>
              <div style={{ fontWeight: 700 }}>
                {_formatMoney(ArrPackage[dataIsu?.package - 1]?.fees)} VNĐ/năm
              </div>
            </div>
            <div style={{ padding: "0px 3%" }}>
              <div
                style={{
                  padding: "2% 0px",
                  borderBottom: "1px solid #009B4B",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ fontsize: 12, color: "#646D69", width: "150px" }}>
                  Thời hạn bảo hiểm
                </div>
                <div style={{ fontWeight: 700 }}>1 năm</div>
              </div>
            </div>
            {(["app", "zalo_mini"].includes(getParamUrlByKey("platform")) && subsidyAmount > 0) && (
              <Row
                style={{
                  alignItems: "flex-start",
                  padding: "0px 3%",
                  marginTop: "2%",
                }}
              >
                <Col xs={24}>
                  <div style={css.titleInput}>Khoản trợ giá</div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                      background: "#ffffff",
                      overflow: "hidden",
                      padding: "8px 10px",
                    }}
                  >
                    <input
                      type="text"
                      inputMode="numeric"
                      placeholder="Nhập số tiền trợ giá"
                      value={subsidyInput}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/\./g, "");
                        if (raw === "" || raw === "0") {
                          setSubsidyInput("");
                          setSubsidy(0);
                          return;
                        }
                        if (!/^\d+$/.test(raw)) return;
                        const maxSubsidy = subsidyAmount;
                        const val = parseInt(raw);
                        if (val <= 0) {
                          setSubsidyInput("");
                          setSubsidy(0);
                          return;
                        }
                        if (val > maxSubsidy) {
                          setSubsidyInput(_formatMoney(maxSubsidy));
                          setSubsidy(maxSubsidy);
                        } else {
                          setSubsidyInput(_formatMoney(val));
                          setSubsidy(val);
                        }
                      }}
                      style={{
                        flex: 1,
                        border: "none",
                        outline: "none",
                        fontSize: 14,
                        color: "#3A3A3A",
                        background: "transparent",
                      }}
                    />
                    <span
                      style={{
                        color: "#9A9A9A",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                        paddingRight: 10,
                      }}
                    >
                      VNĐ
                    </span>
                    {subsidyInput && (
                      <CloseOutlined
                        onClick={() => {
                          setSubsidyInput("");
                          setSubsidy(0);
                        }}
                        style={{
                          fontSize: 14,
                          cursor: "pointer",
                          marginRight: 8,
                          flexShrink: 0,
                        }}
                      />
                    )}
                    <div
                      onClick={() => {
                        const maxSubsidy = subsidyAmount;
                        if (subsidy < maxSubsidy) {
                          setSubsidyInput(_formatMoney(maxSubsidy));
                          setSubsidy(maxSubsidy);
                        }
                      }}
                      style={{
                        cursor: subsidy >= subsidyAmount || subsidyAmount <= 0
                          ? "not-allowed"
                          : "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        background:
                          subsidy >= subsidyAmount || subsidyAmount <= 0
                            ? "#D2D2D2"
                            : "#F0F2F5",
                        border: "1px solid #D2D2D2",
                        borderRadius: 6,
                        color: subsidy >= subsidyAmount || subsidyAmount <= 0 ? "#9E9E9E" : "#343A40",
                        padding: "4px 6px",
                        whiteSpace: "nowrap",
                        fontSize: 12,
                        fontWeight: 700,
                        flexShrink: 0,
                        pointerEvents:
                          subsidy >= subsidyAmount || subsidyAmount <= 0
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img src={IconArrowUp} alt="arrow up" style={{ width: 16, height: 16 }}/>
                      <b>Tối đa</b>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#F58220",
                      marginTop: 4,
                      marginBottom: 4,
                      fontStyle: "italic",
                    }}
                  >
                    Khoản trợ giá tối đa:{" "}
                    <span style={{ fontWeight: 700 }}>
                      {_formatMoney(subsidyAmount)} 
                    </span> VNĐ
                  </div>
                </Col>
              </Row>
            )}
            <Row
              style={{
                alignItems: "flex-end",
                padding: "0px 3%",
                marginTop: "2%",
                display: dataCondition?.display === 1 ? "" : "none",
              }}
            >
              <Col xs={24}>
                <div style={css.titleInput}>Mã giảm giá</div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ position: "relative", width: "75%" }}>
                    <img style={css.iconInput} src={Iticket} alt="quyen loi" />
                    <Form.Item
                      name="redeem"
                      rules={[
                        {
                          required:
                            dataCondition?.required === 1 ? true : false,
                          message: "Vui lòng nhập mã giảm giá của bạn.",
                        },
                      ]}
                      style={{
                        width: "100%",
                        borderRadius: 8,
                        margin: "0px 0px 5px 0px",
                        padding: 0,
                      }}
                    >
                      <Input
                        autoComplete="off"
                        name="redeem"
                        style={{ ...css.input }}
                        placeholder="Nhập mã ưu đãi"
                        disabled={dataCheckReDeem?.code ? true : false}
                        onChange={(e) => {
                          onChangForm({
                            data: e.target.value,
                            name: e.target.name,
                          });
                        }}
                      />
                    </Form.Item>
                    {loadRedeem ? (
                      <LoadingOutlined style={css.closeInput} />
                    ) : (
                      <CloseOutlined
                        style={css.closeInput}
                        onClick={() => clearRedeem()}
                      />
                    )}
                  </div>
                  <div style={{ width: "23%" }}>
                    <div
                      onClick={() => {
                        if (formData?.redeem) {
                          checkReem();
                        }
                      }}
                      style={
                        form.getFieldValue("redeem")
                          ? css.buttonRedeem
                          : css.buttonRedeemDisabled
                      }
                    >
                      Áp dụng
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: !dataCheckReDeem?.code ? "red" : "green",
                    display: dataCheckReDeem ? "" : "none",
                  }}
                >
                  {errRedeem || ""}
                </div>
              </Col>
            </Row>
            <div style={{ padding: "0px 3%", margin: "2% 0px 3% 0px" }}>
              <Spin spinning={loading}>
                <div
                  style={{
                    border: "1px solid #009B4B",
                    background: "#ffffff",
                    padding: 7,
                    borderRadius: 7,
                    color: "#383D3B",
                  }}
                >
                  <div
                    style={{
                      padding: "5px 0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "150px" }}>Tổng phí bảo hiểm: </div>
                    <div>
                      {_formatMoney(ArrPackage[dataIsu?.package - 1]?.fees)} VNĐ
                    </div>
                  </div>
                  <div
                    style={{
                      padding: "5px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "150px" }}>Ưu đãi</div>
                    {!dataCheckReDeem?.amount &&
                      !dataCheckReDeem?.redeemFull && <div>0 VNĐ</div>}
                    {+dataCheckReDeem?.amount > 0 && (
                      <div>-{_formatMoney(dataCheckReDeem?.amount)} VNĐ</div>
                    )}
                    {+dataCheckReDeem?.redeemFull > 0 && (
                      <div>-{_formatMoney(redeemFee)} VNĐ</div>
                    )}
                  </div>
                  {(["app", "zalo_mini"].includes(getParamUrlByKey("platform")) && subsidyAmount > 0) && <div
                    style={{
                      padding: "5px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ width: "150px" }}>Trợ giá</div>
                    <div>{_formatMoney(subsidy)} VNĐ</div>
                  </div>}
                  {showReward && (
                    <div
                      style={{
                        padding: "5px 0px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ width: "150px" }}>
                        Áp dụng tiền thưởng:{" "}
                      </div>
                      <div>-{_formatMoney(reward || 0)} VNĐ</div>
                    </div>
                  )}
                  <div
                    style={{
                      padding: "8px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{ fontSize: 16, width: "170px", fontWeight: 500 }}
                    >
                      Tổng tiền thanh toán
                    </div>
                    <div
                      style={{
                        fontWeight: 700,
                        color: "#009B4B",
                        fontSize: 16,
                      }}
                    >
                      {_formatMoney(
                        Math.max(0, ArrPackage[dataIsu?.package - 1]?.fees -
                          (reward || 0) -
                          (redeemFee || 0) -
                          (subsidy || 0))
                      )}{" "}
                      VNĐ
                    </div>
                  </div>
                </div>
              </Spin>
            </div>
            {/* Lương doanh thu tam thoi an */}
            <div
              style={{
                padding: "0px 3%",
                margin: "3% 0px 10%",
                display: ["app", "zalo_mini"].includes(
                  getParamUrlByKey("platform")
                )
                  ? ""
                  : "none",
              }}
            >
              <div
                style={{
                  border: "1px solid #F58220",
                  background: "#ffffff",
                  padding: 7,
                  borderRadius: 7,
                  color: "#383D3B",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{ fontSize: 16, width: "150px", fontWeight: 500 }}
                  >
                    Lương doanh thu
                  </div>
                  <div
                    style={{ fontWeight: 700, color: "#F58220", fontSize: 16 }}
                  >
                    {loadingBonus ? (
                      <DotLoading style={{ color: "#009b4b" }} />
                    ) : (
                      _formatMoney(Math.max(0, bonus - (subsidy || 0)))
                    )}{" "}
                    VNĐ
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <div style={{ height: 120, width: "100%" }}></div>
          <div
            style={{
              borderRadius: "16px 16px 0px 0px",
              justifyContent: "center",
              padding: "16px",
              boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
              width: "100%",
              background: "#ffffff",
              left: 0,
              right: 0,
              zIndex: 3,
              position: "fixed",
              bottom: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <div>Tổng tiền thanh toán</div>
              {!dataCheckReDeem?.amount && !dataCheckReDeem?.redeemFull && (
                <div>
                  <span
                    style={{ fontWeight: 500, color: "#009B4B", fontSize: 18 }}
                  >
                    {_formatMoney(
                      Math.max(0, ArrPackage[dataIsu?.package - 1]?.fees - (reward || 0) - (subsidy || 0))
                    )}
                  </span>
                  <span style={{ color: "#9A9A9A", fontSize: 14 }}> VNĐ</span>
                </div>
              )}
              {+dataCheckReDeem?.amount > 0 && (
                <div>
                  <span
                    style={{ fontWeight: 500, color: "#009B4B", fontSize: 18 }}
                  >
                    {_formatMoney(
                      Math.max(0, ArrPackage[dataIsu?.package - 1]?.fees -
                        parseInt(dataCheckReDeem?.amount) -
                        (reward || 0) -
                        (subsidy || 0))
                    )}
                  </span>
                  <span style={{ color: "#9A9A9A", fontSize: 14 }}> VNĐ</span>
                </div>
              )}
              {+dataCheckReDeem?.redeemFull > 0 && (
                <div>
                  <span
                    style={{ fontWeight: 600, color: "#009B4B", fontSize: 19 }}
                  >
                    {_formatMoney(
                      Math.max(0, ArrPackage[dataIsu?.package - 1]?.fees -
                        ArrPackage[dataIsu?.package - 1]?.fees *
                        (+dataCheckReDeem?.redeemFull / 100) -
                        (reward || 0) -
                        (subsidy || 0))
                    )}
                  </span>
                  <span style={{ color: "#9A9A9A", fontSize: 14 }}> VNĐ</span>
                </div>
              )}
            </div>
            <BackButton
              onNext={() => onFinish()}
              onBack={() => goStep(3)}
              total={true}
              disabled={clickButton}
            />
          </div>
        </Row>
      </Form>
      <ModalVAT handleCancel={handleCancel} isModalVisible={isModalVisible} />
      <SuccessModal open={openDone} dataOrder={dataOrder} />
      {showLoading && <LoadingModal isOpen={showLoading} />}
    </div>
  );
};

export default CreateOrder;

const css = {
  input: {
    color: "#3A3A3A",
    zIndex: 1,
    fontSize: 15,
    boxShadow: "none",
    padding: "10px 35px",
    borderRadius: 9,
    width: "100%",
  },
  titleInput: { color: "#646D69", marginBottom: 3 },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  iconInput: {
    width: 20,
    margin: "12px 10px",
    position: "absolute",
    zIndex: 2,
  },
  closeInput: {
    width: 20,
    margin: "16px 8px",
    position: "absolute",
    top: 0,
    right: 0,
    zIndex: 2,
  },
  buttonRedeem: {
    cursor: "pointer",
    fontWeight: 600,
    background: "#F58220",
    borderRadius: 8,
    color: "#ffffff",
    textAlign: "center",
    padding: "11px 0px",
  },
  buttonRedeemDisabled: {
    cursor: "pointer",
    fontWeight: 600,
    background: "#FFFFFF",
    borderRadius: 8,
    color: "#646D69",
    textAlign: "center",
    padding: "11px 0px",
    border: "1px solid #d9d9d9",
  },
  button: {
    fontSize: 14,
    background: "#009B4B",
    color: "#ffffff",
    width: "100%",
    textAlign: "center",
    borderRadius: 8,
    fontWeight: 500,
    height: 45,
    border: "1px solid #009B4B",
  },
  buttonDisabled: {
    fontSize: 14,
    background: "#F6F6F6",
    color: "#9A9A9A",
    width: "100%",
    textAlign: "center",
    borderRadius: 8,
    fontWeight: 500,
    height: 45,
    border: "1px solid #F6F6F6",
  },
};
